module.exports = {
      id: "customer-usage",
      viewBox: "0 0 30 30",
      url: __webpack_public_path__ + "img/icons.400d09d6.svg#customer-usage",
      toString: function () {
        return this.url;
      }
    }